const docHR = {
  User: 'Korisnik',
  Users: 'Korisnici',
  AddUser: 'Dodaj novog korisnika',
  email: 'email',
  password: 'password',
  ConfirmPassword: 'Potvrdi Password',
  First: 'Ime',
  Last: 'Prezime',
  StartFrom: 'Radi od',
  Activ: 'Aktivan ',
  Admin: 'Admin Global',
  AccessLevel: 'Razina pristupa (1 max, 5 min)',
  UserEmpty: 'Baza korisnika je prazna',
  Actions: 'Akcije',
  NewUser: 'Novi Korisnik',
  EditUser: 'Uredi Korisnika',
  Priv1: '1 najveća prava',
  Priv2: '2 srednja do najveća prva',
  Priv3: '3 srednja prava',
  Priv4: '4 niska do srednja prava',
  Priv5: '5 najniža prava',
  VATID: 'OIB',
  sales1: 'Prodaja',
  sales2: 'NE prikazuj dobavne cijene',
  purchase1: 'Nabava',
  purchase2: 'Nabava Prof',
  crm1: 'CRM',
  crm2: 'CRM Prof',
  finance1: 'Financije',
  finance2: 'Financije Prof',
  finance3: 'Financije Nap',
  finance4: 'Financije Nap Prof',
  hr1: 'Ljudski resursi',
  hr2: 'Ljudski resursi Prof',
  admin1: 'Admin Firma',
  admin2: 'Admin Firma Prof',
  prod1: 'Proizvodnja',
  prod2: 'Proizvodnja Prof',
  privatePartner: 'Privatni Part',
  chart1: 'Graf 1',
  chart2: 'Graf 2',
  chart3: 'Graf 3',
  chart4: 'Graf 4',
  salesNumbers1: 'Prodaja1',
  salesNumbers2: 'Prodaja2',
  calendar1: 'Kalendar 1',
  calendar2: 'Kalendar 2',
  task1: 'Zadaci 1',
  task2: 'Zadaci 2',
  chat1: 'Chat 1',
  chat2: 'Chat 2',
}

export default docHR